module.exports = __webpack_public_path__ + "static/media/login-visual.f7ed5e1d.svg";